import { Model } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'Report';

  static reducer({ type, payload }, Report) {
    switch (type) {
      case ActionTypes.DAILY_REPORTS_FETCH_SUCCEEDED:
        payload.reports.forEach((report) => {
          Report.upsert(report);
        });

        break;
      case ActionTypes.MONTHLY_REPORTS_FETCH_SUCCEEDED:
        payload.reports.forEach((report) => {
          Report.upsert(report);
        });

        break;
      case ActionTypes.YEARLY_REPORTS_FETCH_SUCCEEDED:
        payload.reports.forEach((report) => {
          Report.upsert(report);
        });

        break;
      default:
    }
  }
}
